import { render } from "./LinkView.vue?vue&type=template&id=b1b6ec40&scoped=true"
import script from "./LinkView.vue?vue&type=script&lang=js"
export * from "./LinkView.vue?vue&type=script&lang=js"

import "./LinkView.vue?vue&type=style&index=0&id=b1b6ec40&scoped=true&lang=css"

import exportComponent from "/Users/rose/src/golinks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b6ec40"]])

export default __exports__